export {};

import { initGame } from "./game/game-controller";

initGame();
